// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"110":"4798245c","997":"4798245c"}[chunkId] + ".chunk.css";
};